export default "__VITE_ASSET__BiA6Dzr$__"